import {inject, Injectable} from '@angular/core';
import {AbstractMessageListenerService} from "./abstract-message-listener.service";
import {Router} from "@angular/router";
import {PlayerStore} from "../store/player.store";
import {isHost} from "../shared/util/window.util";

@Injectable({
  providedIn: 'root'
})
export class BackToLobbyMessageService extends AbstractMessageListenerService<any> {

  constructor(private router: Router) {
    super('backToLobby');
  }

  public override process(): void {
    if (isHost()) {
      this.router.navigate(['host', this.room?.roomId]);
    } else {
      this.router.navigate(['lobby', this.room?.roomId]);
    }
  }
}
